import { useEffect } from 'react'
import { useAppDispatch, useAppSelector } from '../hooks/useAppStore'
import { selectCurrentUser } from '../store/slices/authSlice'
import { useGetProfileQuery } from '../store/api/apiSlice'
import { setCredentials } from '../store/slices/authSlice'

export default function AuthInitializer({ children }: { children: React.ReactNode }) {
    const dispatch = useAppDispatch()
    const currentUser = useAppSelector(selectCurrentUser)
    const token = localStorage.getItem('access_token')
    
    // Only fetch profile if we have a token but no user in Redux
    const shouldFetchProfile = !!token && !currentUser
    
    const { data: profileData, isSuccess, isLoading } = useGetProfileQuery(undefined, {
        skip: !shouldFetchProfile,
    })

    useEffect(() => {
        if (isSuccess && profileData && token) {
            // Rehydrate Redux state with user data from profile
            dispatch(setCredentials({
                user: profileData,
                token: token,
            }))
        }
    }, [isSuccess, profileData, token, dispatch])

    // Show loading state while fetching profile on app initialization
    if (shouldFetchProfile && isLoading) {
        return (
            <div className="flex items-center justify-center min-h-screen bg-[#EDEFF3]">
                <div className="text-center">
                    <div className="w-16 h-16 border-4 border-gray-200 border-t-gray-900 rounded-full animate-spin mx-auto mb-4"></div>
                    <p className="text-gray-600">Loading your profile...</p>
                </div>
            </div>
        )
    }

    return <>{children}</>
}
